module.exports = __webpack_public_path__ + "img/chinesecompany132.52124e47.png";